// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TitleBlock_titleContainer__ty0MY","fullWidth":"TitleBlock_fullWidth__UnuNz","leftAlign":"TitleBlock_leftAlign__3kDKx","v2":"TitleBlock_v2__bkiC3"};